module.exports = {
    base_url: '',
    // base_url: 'http://127.0.0.1:8098',
    // base_url: 'http://192.168.0.65:8098',
    // mode: 'local',
    file_domain: "https://file.17lianqin.cn",
    languages: [
        {
            value: 'zh',
            label: '中文'
        },
        {
            value: 'en',
            label: 'English'
        }
    ],
    menu_config: {
        router_name: 'home',
        display_name: 'menu.home',
        sub_menus:[
            {
                router_name: 'albums',
                display_name: 'menu.album',
                sub_menus: [
                    {
                        router_name: 'album_new',
                        display_name: 'menu.album_new'
                    },
                    {
                        router_name: 'album_edit',
                        display_name: 'menu.album_edit'
                    },
                    {
                        router_name: 'album_detail',
                        display_name: 'menu.album_detail',
                        sub_menus: [
                            {
                                router_name: 'sheet_detail',
                                display_name: 'menu.sheet_detail'
                            }
                        ]
                    },
                    {
                        router_name: 'sheet_new',
                        display_name: 'menu.sheet_new'
                    },
                    {
                        router_name: 'sheet_edit',
                        display_name: 'menu.sheet_edit'
                    },
                ]
            }
        ]
    },
    album_scope: [
        'public',
        'private',
        'team',
        'organization'
    ],
    score_options: {
        violin:{fullName: "小提琴", fullName_en: "Violin", shortName: "小提", shortName_en: "VIn.", instrument: "violin"},
        violinI:{fullName: "第一小提琴", fullName_en: "Violin I", shortName: "一提", shortName_en: "Vn.I", instrument: "violin"},
        violinII:{fullName: "第二小提琴", fullName_en: "Violin II", shortName: "二提", shortName_en: "Vn.II", instrument: "violin"},
        violinIII:{fullName: "第三小提琴", fullName_en: "Violin III", shortName: "三提", shortName_en: "Vn.III", instrument: "violin"},
        violinIV:{fullName: "第四小提琴", fullName_en: "Violin IV", shortName: "四提", shortName_en: "Vn.IV", instrument: "violin"},
        viola:{fullName: "中提琴", fullName_en: "Viola", shortName: "中提", shortName_en: "Va.", instrument: "viola"},
        violaI:{fullName: "第一中提琴", fullName_en: "Viola I", shortName: "中一", shortName_en: "Va.I", instrument: "viola"},
        violaII:{fullName: "第二中提琴", fullName_en: "Viola II", shortName: "中二", shortName_en: "Va.II", instrument: "viola"},
        cello:{fullName: "大提琴", fullName_en: "Cello", shortName: "大提", shortName_en: "Vc.", instrument: "cello"},
        celloI:{fullName: "第一大提琴", fullName_en: "Cello I", shortName: "大一", shortName_en: "Vc.I", instrument: "cello"},
        celloII:{fullName: "第二大提琴", fullName_en: "Cello II", shortName: "大二", shortName_en: "Vc.II", instrument: "cello"},
        oboe:{fullName: "双簧管", fullName_en: "Oboe", shortName: "双簧", shortName_en: "Ob.", instrument: "oboe"},
        oboeI:{fullName: "第一双簧管", fullName_en: "Oboe I", shortName: "双簧一", shortName_en: "Ob.I", instrument: "oboe"},
        oboeII:{fullName: "第二双簧管", fullName_en: "Oboe II", shortName: "双簧二", shortName_en: "Ob.II", instrument: "oboe"},
    },
    available_language: {
        zh: {name: '中文', key: 'zh'},
        base: {name: '默认语言', key: 'base'},
        en: {name: '英文', key: 'en'},
        ko: {name: '韩文', key: 'ko'},
        ja: {name: '日文', key: 'ja'},
        ru: {name: '俄文', key: 'ru'},
        es: {name: '西文', key: 'es'},
        de: {name: '德文', key: 'de'},
        it: {name: '意大利文', key: 'it'},
        he: {name: '希伯来文', key: 'he'},
        pt: {name: '葡萄牙文', key: 'pt'},
        zh_tw: {name: '繁体中文', key: 'zh_tw'},
    },
};
